export default __webpack_public_path__ + "static/media/WishWell.f4071c5c.png";